const ROUTE_LABELS = {
  "/home": "Home",
  "/gitflow-release-management": "GitFlow Release Management",
  "/gitflow-hotfix-management": "GitFlow Hotfix Management",
  "/tbd-release-management": "Trunk-Based Release Management",
  "/multi-deployment": "Multi-Deployment",
  "/priority-groups": "Priority Groups",
  "/opened-release-hotfixes": "Opened Releases & Hotfixes",
  "/state": "State",
  "/sctk": "SCTK",
  "/aws-secrets-manager": "AWS Secrets Manager",
  "/aws-parameter-store-manager": "AWS Parameter Store Manager",
  "/aws-cache-manager": "AWS Cache Manager",
  "/iac-tfstate-unlock": "IaC / TF State Unlock",
  "/util": "Utils",
  "/util/crypto": "Crypto",
  "/util/keys": "Keys",
  "/util/git": "Git",
  "/util/git/pr-management": "PR Management",
  "/util/github-migration": "Azure to GitHub Migration",
  "/user-management": "User Management",
  "/user-management/edit-user": "Edit User",
  "/user-management/attach-tenants": "Attach Tenants",
  "/role-management": "Role Management",
  "/tenant-management": "Tenant Management",
  "/ai-mode": "AI Mode",
  "/ai-mode/ai-augmented-sdlc": "AI-Augmented SDLC",
  "/ai-mode/ai-chat-agent": "AI Chat Agent",
  "/ai-mode/ai-settings": "AI Settings",
};

export default ROUTE_LABELS;